<template>
    <div class="field field--checkbox">
        <input
            type="radio"
            v-if="fakeRadio" />
        <input
            v-else
            :id="id"
            :value="radioValue"
            v-model="inputVal"
            type="radio"
            :name="name"
            :required="required"
            :disabled="disabled"
        />
        <label
            :for="id"
        ><span>{{ label }}</span></label
        >
    </div>
</template>

<script>
export default {
    name: 'CoreRadio',
    props: {
        initial: {
            default: null
        },
        id: {
            type: String,
            default() {
                return `radio-input-${this._uid}`;
            }
        },
        value: {
            type: [String, Number]
        },
        radioValue: {
            type: [String, Number]
        },
        label: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: 'radio'
        },
        required: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        fakeRadio: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        inputVal: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
input[type="radio"] {
    display: none;
}

.field--checkbox {
    input + label {
        position: relative;

        display: inline-flex;
        align-items: center;

        cursor: pointer;

        line-height: 1rem;
    }

    input + label {
        display: inline-flex;
        align-items: center;

        cursor: pointer;

        line-height: 1rem;
    }

    input + label {
        &::before {
            width: 20px;
            height: 20px;

            border: 1px solid var(--border-grey-50);
            background-color: var(--white);
        }

        &::after {
            position: absolute;
            top: 50%;
            left: 5px;

            width: 10px;
            height: 10px;

            transform: translateY(-50%);
        }

        &::before,
        &::after {
            margin-right: 1rem;

            content: "";

            border-radius: 50%;
        }
    }

    input:checked + label {
        // border-width: 1px;
        // border-color: var(--tertiary);

        &::after {
            background-color: var(--primary);
        }
    }
}
</style>
